const TAG_COLORS = [
  {
    name: "Most Least Assets",
    colorClass: "most-least-assets",
  },
  {
    name: "Active",
    colorClass: "active-badge",
  },
  {
    name: "Inactive",
    colorClass: "inactive-badge",
  },
  {
    name: "Subscriber",
    colorClass: "subscriber-badge",
  },
];

export default TAG_COLORS;
